import {animate, keyframes, state, style, transition, trigger, query, group} from '@angular/animations';
// import { setClassMetadata } from '@angular/core/src/r3_symbols';

export const on_off_animation =
  trigger('itemAppear', [
    transition(':enter', [
        style({ opacity: '0', transform: 'scale(.1)' }),
        animate(300)
      ]),
      transition(':leave', [
        style({ opacity: '.5', transform: 'scale(.1)' }),
        animate(300)
      ])
    ]);

    // trigger('detailAppear', [
    //   transition(':enter', [
    //       style({ opacity: '0', transform: 'scale(.1)' }),
    //       animate(300)
    //     ]),
    //     transition(':leave', [
    //       style({ opacity: '.5', transform: 'scale(.5)' }),
    //       animate(300)
    //     ])
    //   ]);